import i18next from 'i18next'

import { getCurrentLanguage } from './getCurrentLanguage'

export const setLanguage = async newLanguage => {
  await i18next.changeLanguage(newLanguage)

  return getCurrentLanguage()
}
